import React, { Component } from "react";
import "./EditorToolbar.scss";
import {
  DWDark,
  DWLight,
  FSDark,
  FSLight,
  PLDark,
  PLLight,
  STDark,
  STLight,
} from "../../assets";
import { returnCount } from "../../utils/text";
import ReactTooltip from "react-tooltip";
export default class EditorToolbar extends Component {
  state = {
    ctrlKeyValue: "Ctrl",
  };

  componentDidMount() {
    if (window.navigator.platform === "MacIntel") {
      this.setState({ ctrlKeyValue: "Cmd" });
    }
  }

  getPlayStopIcon = (light, isSpeaking) => {
    if (isSpeaking) {
      return light ? STLight : STDark;
    } else {
      return light ? PLLight : PLDark;
    }
  };

  toggleSpeechState = () => {
    if (this.props.isSpeaking) {
      window.speechSynthesis.cancel();
    }
  };

  render() {
    let { ctrlKeyValue } = this.state;
    let {
      light,
      toggleFullScreen,
      toggleLightMode,
      saveFile,
      bodyText,
      isSpeechSupported,
      isSpeaking,
      speechRecognition,
    } = this.props;

    return (
      <div
        className={
          light
            ? "editor-toolbar__wrapper editor-toolbar__wrapper--light"
            : "editor-toolbar__wrapper"
        }
      >
        {/* eslint-disable-next-line */}
        <div className="editor-toolbar__top">
          {/* eslint-disable-next-line */}
          <a href={null} data-tip="Words (approx)">
            <button
              className={
                light
                  ? "editor-toolbar__button editor-toolbar__button--light"
                  : "editor-toolbar__button"
              }
            >
              <span
                className={
                  returnCount(bodyText) < 100
                    ? "editor-toolbar__word-count"
                    : returnCount(bodyText) < 1000
                    ? "editor-toolbar__word-count--md"
                    : "editor-toolbar__word-count--sm"
                }
              >
                {returnCount(bodyText)}
              </span>
            </button>
          </a>
          {/* eslint-disable-next-line */}
          <a href={null} data-tip={`Theme (${ctrlKeyValue}+U)`}>
            <button
              onClick={toggleLightMode}
              className={
                light
                  ? "editor-toolbar__button editor-toolbar__button--light"
                  : "editor-toolbar__button"
              }
            >
              {light ? "L" : "D"}
            </button>
          </a>
          {/* eslint-disable-next-line */}
          <a href={null} data-tip={`Fullscreen (${ctrlKeyValue}+F)`}>
            <button
              onClick={toggleFullScreen}
              className={
                light
                  ? "editor-toolbar__button editor-toolbar__button--light"
                  : "editor-toolbar__button"
              }
            >
              <img
                className="editor-toolbar__icon"
                src={light ? FSLight : FSDark}
                alt="fulllscreen"
              />
            </button>
          </a>
          {/* eslint-disable-next-line */}
          <a href={null} data-tip={`Download (${ctrlKeyValue}+D)`}>
            <button
              onClick={saveFile}
              className={
                light
                  ? "editor-toolbar__button editor-toolbar__button--light"
                  : "editor-toolbar__button"
              }
            >
              <img
                className="editor-toolbar__icon"
                src={light ? DWLight : DWDark}
                alt="download"
              />
            </button>
          </a>
        </div>
        {isSpeechSupported ? (
          <div className="editor-toolbar__bottom">
            {/* eslint-disable-next-line */}
            <a href={null} data-tip={`Listen (${ctrlKeyValue}+L)`}>
              <button
                onClick={
                  isSpeaking
                    ? () => this.toggleSpeechState()
                    : () => speechRecognition()
                }
                className={
                  isSpeaking
                    ? light
                      ? "editor-toolbar__button editor-toolbar__button--light listen__button listen__button__red--light"
                      : "editor-toolbar__button listen__button listen__button__red"
                    : light
                    ? "editor-toolbar__button editor-toolbar__button--light listen__button listen__button__green--light"
                    : "editor-toolbar__button listen__button listen__button__green"
                }
                style={
                  isSpeaking
                    ? {
                        animation: `fluctuate 0.5s 0.1s infinite`,
                      }
                    : null
                }
              >
                <img
                  className="editor-toolbar__icon editor-toolbar__icon--speak"
                  src={this.getPlayStopIcon(light, isSpeaking)}
                  alt="Listen"
                />
              </button>
            </a>
          </div>
        ) : null}
        <ReactTooltip
          className="editor-toolbar__tooltip"
          place="right"
          delayShow={100}
          type={light ? "dark" : "light"}
          effect="solid"
          offset={{ top: 4 }}
        />
      </div>
    );
  }
}
